import Support from "./support";
import NewTicket from './NewTicket';
import TicketDetails from './TicketDetails';
import AgentQueue from './AgentQueue';
import KnowledgeBase from './KnowledgeBase';
import AgentWork from "./AgentWork";
import AdminDashboard from './AdminDashboard'

export default Support;
export { Support, NewTicket, TicketDetails, AgentQueue, KnowledgeBase, AgentWork, AdminDashboard };